import { useState } from "react";
import { Modal } from "../../components/ui/Modal";
import { ErrorState, LoadingState } from "../../components/StatusView";
import { CreateServerForm } from "../../features/servers/CreateServerForm";
import { ServersTable } from "../../features/servers/ServersTable";
import { useServers } from "../../features/servers/serverHooks";

export function ConsoleServersPage() {
  const { state, reload } = useServers();
  const [creating, setCreating] = useState(false);
  const [busy, setBusy] = useState(false);

  return (
    <div className="console-page">
      <div className="console-page-head">
        <h1 className="console-page-title">Servers</h1>
        <p className="console-page-sub">
          Register globally unique products on resources. Registrations reserve your product ID;
          client connectivity uses this provisioning.
        </p>
      </div>

      <div className="server-actions">
        <button type="button" className="btn btn--primary" onClick={() => setCreating(true)}>
          Create Server
        </button>
      </div>
      {creating && (
        <Modal title="Create Server" onClose={() => setCreating(false)} busy={busy}>
          <p className="form-note">
            Choose a product type, tick rate and concurrent-user allocation. Capacity is reserved
            from your account budget.
          </p>
          <CreateServerForm
            onSettled={reload}
            onCreated={() => setCreating(false)}
            onBusyChange={setBusy}
            serversReady={state.status === "ready"}
          />
        </Modal>
      )}

      {state.status === "loading" ? (
        <LoadingState label="Loading servers…" />
      ) : state.status === "error" ? (
        <ErrorState message={state.message} onRetry={reload} />
      ) : (
        <ServersTable servers={state.data.items} />
      )}
    </div>
  );
}
